module.exports = __webpack_public_path__ + "static/media/bg-pattern-top-mobile.7fcc4667.svg";